<template>
    <div ref="box" style="display:none;" class="headContent">
        <!-- 头部 -->
        <div class="emplyee-header">
            <header-top
                @listentochildevent="getKeyword"
                :total="total"
            ></header-top>
        </div>
        <!-- 表格部分 -->
        <div class="table-content">
            <table-content
                :table-list="tableData.list"
                @dropList="getEmplyeeTableList"
                @mark="getEmplyeeTableList"
                :loading="emplyeeLoading"
                :tablePage="page"
            ></table-content>
        </div>
        <div class="table-pagination">
            <page-component
                :total="total"
                :current-page="page"
                @pagechange="getEmplyeeTableList"
            ></page-component>
        </div>
        <registered-account
            @registerSubAccount="getEmplyeeTableList"
            :currentPage="page"
        ></registered-account>
        <del-msgbox @del="getEmplyeeTableList" :currentPage="page"></del-msgbox>
    </div>
</template>

<script>
// 头部
import HeaderTop from "./include/header";
// 表格内容
import TableContent from "./include/table";
// 分页功能
import PageComponent from "_c/pagination/pageComponent";
// 注册子账号和修改的弹窗
import RegisteredAccount from "./include/registeredSubAccount";
// 删除弹窗
import DelMsgbox from "./include/del";

import { getEmplyeeTableList } from "@/requests/emplyee";
export default {
    name: "emplyeeManage",
    components: {
        HeaderTop,
        TableContent,
        PageComponent,
        RegisteredAccount,
        DelMsgbox
    },
    data() {
        return {
            total: 0,
            page: 1,
            tableData: {
                list: []
            },
            deleteAllStatus: false,
            searchTxt: "",
            emplyeeLoading: false
        };
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                // this.$domFn.addAnimateClass(this.$refs.box, 'animated fadeInRight')
                this.$refs.box.style.display = "block";
            });
        });
        this.getEmplyeeTableList(1);
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.getEmplyeeTableList(1);
        });
    },
    methods: {
        getKeyword(data) {
            this.searchTxt = data;
            this.getEmplyeeTableList(1);
        },
        // 获取员工管理列表
        async getEmplyeeTableList(page) {
            this.emplyeeLoading = true;
            let res = await getEmplyeeTableList({
                page,
                pageSize: 20,
                search: this.searchTxt
            });
            res.list.forEach(item => {
                item.passportPermissionList.forEach(i => {
                    if (i.productId == 10000 && i.permValue == 7) {
                        i.permValue = 3;
                    }
                });
            });
            this.tableData.list = res.list;
            this.total = parseInt(res.total);
            this.page = parseInt(res.page);
            this.emplyeeLoading = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.headContent {
    position: absolute;
    min-width: 1140px;
    left: 0px;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    overflow-y: auto;
}
.emplyee-header {
    height: 70px;
    // line-height: 70px;
    border-bottom: 1px solid #d9dee4;
    overflow: hidden;
}
.table-content {
    padding-top: 10px;
    padding-left: 30px;
    padding-right: 30px;
}
.table-pagination {
    padding: 20px 80px 20px 0px;
    display: inline-block;
    float: right;
}
</style>
